import { Container } from "@mui/material";
import CustomMetas from "../components/custom-metas/customMetas";
import { getClient } from "../Providers/graphqlClient";
import { GET_CMS_PAGE } from "../graphql/cms/queries";
import { CmsPageParser } from "../components/cms-parser";
import { GET_STORE_CMS_BASE_LINKS } from "../graphql/store/queries";

const NotFound = (props) => {

    const { id, page } = props
    const { content } = page

    return (
        <Container maxWidth="xl" sx={{ textAlign: "center", mt: { xs: 3, lg: 5 } }}>
            <CustomMetas title={page.meta_title}
                description={page.meta_description}
                keywords={page.meta_keywords}
            />
            <CmsPageParser key={id} id={id} >{content}</CmsPageParser>
        </Container >
    )
}

export const getStaticProps = async (context) => {
    const client = getClient(context.locale, null)
    const { data: baseLinksData } = await client.query({
        query: GET_STORE_CMS_BASE_LINKS
    })
    console.log("xxx");
    const baseLinks = baseLinksData.baseLinks
    console.log("xxx");

    const { data: pageData } = await client.query({
        query: GET_CMS_PAGE,
        variables: { id: baseLinks.cms_no_route }
    })
    console.log("xxx");

    return {
        props: {
            page: pageData.cmsPage,
            id: baseLinks.cms_no_route
        },
        revalidate: 10
    }
}

export default NotFound;